<template>
  <div class="router-page">
    <!-- <Button type="primary" icon="plus-round" @click="edit(-1)">新建路由器</Button> -->
    <el-table class="account-table" highlight-row stripe border :data="datas">
      <el-table-column type="index" :label="$t('device.router.index')" width="65px"></el-table-column>
      <el-table-column :label="$t('monitor.Collector.status1')" width="95px">
        <template slot-scope="scope">
          <div :class="scope.row.online === 1 ? 'dot green' : 'dot gray'"></div>
        </template>
      </el-table-column>
      <el-table-column prop="AnotherName" :label="$t('device.router.AnotherName')"></el-table-column>
      <el-table-column prop="name" :label="$t('device.router.name')"></el-table-column>
      <el-table-column prop="channel" :label="$t('device.router.channel')"></el-table-column>
      <el-table-column prop="localAddr" label="Local IP"></el-table-column>
      <el-table-column prop="remark" :label="$t('device.router.remark')"></el-table-column>
      <el-table-column :label="$t('device.router.action')" width="100px">
        <template slot-scope="scope">
          <el-button v-if="permissions === true" @click.native="edit(scope.row.id)" type="primary" size="small">{{$t('device.router.edit')}}</el-button>
          <el-button v-if="permissions !== true" type="primary" size="small" disabled>{{$t('device.router.edit')}}</el-button>
          <!-- <el-button v-if="permissions === true" @click.native="setTm(scope.row.id)" type="primary" size="small">{{$t('device.router.time')}}</el-button>
          <el-button v-if="permissions !== true" type="primary" size="small" disabled>{{$t('device.router.time')}}</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!-- <Table class="router-table" highlight-row stripe border :columns="columns" :data="datas"></Table> -->
  </div>
</template>
<script>
import { Api } from '@/api'
export default {
  name: 'Router',
  data () {
    return {
      // columns: [
      //   { type: 'index', title: this.$t('device.router.index') },
      //   { title: this.$t('device.router.AnotherName'), key: 'AnotherName' },
      //   { title: this.$t('device.router.name'), key: 'name' },
      //   { title: this.$t('device.router.linkType'),
      //     key: 'linkType',
      //     render: (h, params) => {
      //       let b = params.row.linkType === 0 ? this.$t('device.router.Internet') : this.$t('device.router.Lan')
      //       return h('span', b)
      //     }
      //   },
      //   { title: this.$t('device.router.channel'), key: 'channel' },
      //   { title: this.$t('device.router.remark'), key: 'remark' },
      //   {
      //     title: this.$t('device.router.action'),
      //     key: 'action',
      //     render: (h, params) => {
      //       if (this.permissions === true) {
      //         return h('div', [
      //           h('Button', {
      //             props: {
      //               type: 'primary',
      //               size: 'small'
      //             },
      //             style: {
      //               marginRight: '5px'
      //             },
      //             on: {
      //               click: () => {
      //                 this.edit(params.index)
      //               }
      //             }
      //           }, this.$t('device.router.edit')),
      //           h('Button', {
      //             props: {
      //               type: 'primary',
      //               size: 'small'
      //             },
      //             style: {
      //               marginRight: '5px'
      //             },
      //             on: {
      //               click: () => {
      //                 this.setTm(params.index)
      //               }
      //             }
      //           }, this.$t('device.router.time'))
      //         ])
      //       } else {
      //         return h('div', [
      //           h('Button', {
      //             props: {
      //               type: 'primary',
      //               size: 'small',
      //               disabled: true
      //             },
      //             style: {
      //               marginRight: '5px'
      //             }
      //           }, this.$t('device.router.edit')),
      //           h('Button', {
      //             props: {
      //               type: 'primary',
      //               size: 'small',
      //               disabled: true
      //             },
      //             style: {
      //               marginRight: '5px'
      //             }
      //           }, this.$t('device.router.time'))
      //         ])
      //       }
      //     }
      //   }
      // ],
      datas: [],
      permissions: false
    }
  },
  methods: {
    edit (id) {
      // let id = index === -1 ? 0 : this.datas[index].id
      this.$router.push({ name: 'RouterEdit', params: { id } })
    },
    // remove (index) {
    //   this.$api.router.delete(this.datas[index].id).then(() => {
    //     this.datas.splice(index, 1)
    //   })
    // },
    setTm (id) {
      this.$api.router.collectorsTmSet(id).then(() => {
        this.$Message.config({
          top: 80,
          duration: 2
        })
        this.$Message.success(this.$t('device.router.save_success'))
      })
    }
  },
  mounted () {
    Api.user.fetchUserInfo().then(res => {
      for (let i = 0; i < res.user.permissions.length; i++) {
        if (res.user.permissions[i].action === 'device' && res.user.permissions[i].value === 3) {
          this.permissions = true
        }
      }
    })
  },
  beforeRouteEnter (to, from, next) {
    Api.router.list().then(res => {
      for (let i = 0; i < res.routers.length; i++) {
        let channel = res.routers[i].channel
        if (channel < 10) {
          res.routers[i].channel = String.fromCharCode(channel + 48)
        } else {
          res.routers[i].channel = String.fromCharCode(channel + 55)
        }
      }
      next(vm => { vm.datas = res.routers })
    })
  }
}
</script>
<style scoped>
  .router-page {
    padding: 10px;
  }
  .router-table {
    margin-top: 20px;
  }
  /* .none-border{
    border: none !important;
    padding: 0px;
  } */
  .ivu-tag-dot-inner {
    margin-right: 0px;
  }
  .dot {
    width: 12px;
    height: 12px;
    margin-right: 8px;
    border-radius: 50%;
    margin: 0 auto;
    position: relative;
    top: 1px;
  }
  .gray {
    background: #e9eaec;
  }
  .green {
    background: #19be6b;
  }
</style>





// WEBPACK FOOTER //
// List.vue?209acb06